<template>
  <div class="mx-sm-1 mt-4">
    <div class="page-header mb-4">
      <h1 class="page-title fw-bold">Point de Vente</h1>
    </div>

    <div class="row row-cards">
      <div class="col-xl-3 col-lg-4">
        <CategorySidebar :categories="categories" @select-category="onSelectCategory" />
      </div>

      <div class="col-xl-6 col-lg-8">
        <div class="row mb-3">
          <div class="col">
            <input
                type="text"
                class="form-control"
                placeholder="Rechercher un produit..."
                v-model="searchText"
            />
          </div>
        </div>

        <div class="product-scroll-container">
          <ProductGrid
              :products="filteredProducts"
              :cartItems="cartItems"
              @add-to-cart="addToCart"
              @remove-from-cart="removeCartItem"
          />
        </div>
      </div>

      <div class="col-xl-3 d-none d-xl-block product-scroll-container">
        <CustomerSelector :selectedClient="selectedClient" @select-customer="onSelectCustomer" />
        <CartSummary
            :items="cartItems"
            :client="selectedClient"
            :total="cartTotal"
            @update-qty="updateCartItem"
            @remove-item="removeCartItem"
        />
      </div>
    </div>

    <button class="btn btn-primary d-xl-none fixed-bottom m-3" @click="showCart = true">
      <i class="fe fe-shopping-cart me-2"></i> Voir le panier
    </button>

    <b-modal v-model="showCart" title="Panier" size="lg" hide-footer>
<!--      <CustomerSelector :selectedClient="selectedClient" @select-customer="onSelectCustomer" />-->
      <CartSummary
          :items="cartItems"
          :client="selectedClient"
          :total="cartTotal"
          @update-qty="updateCartItem"
          @remove-item="removeCartItem"
      />
    </b-modal>

    <div class="pos-footer-actions fixed-bottom bg-white border-top py-2 px-3 d-none d-xl-flex justify-content-between">
      <OrderFooterActions
          :isSubmitting="isSubmitting"
          @reset="resetCart"
          @checkout="checkout"
      />
    </div>
  </div>
</template>

<script>
  import CategorySidebar from "@/components/pos/CategorySidebar.vue";
  import ProductGrid from "@/components/pos/ProductGrid.vue";
  import CartSummary from "@/components/pos/CartSummary.vue";
  import CustomerSelector from "@/components/pos/CustomerSelector.vue";
  import OrderFooterActions from "@/components/pos/OrderFooterActions.vue";
  import {showValidationErrors} from "../../../helpers/helpers";

  export default {
    name: "ShopPOS",
    components: {
      CategorySidebar,
      ProductGrid,
      CartSummary,
      CustomerSelector,
      OrderFooterActions
    },
    data() {
      return {
        categories: [],
        products: [],
        searchText: "",
        selectedCategory: null,
        cartItems: [],
        selectedClient: null,
        showCart: false,
        isSubmitting: false
      };
    },
    computed: {
      filteredProducts() {
        return this.products.filter(product => {
          const matchCategory = !this.selectedCategory || product.categoryCode === this.selectedCategory;
          const matchSearch = !this.searchText || product.name.toLowerCase().includes(this.searchText.toLowerCase());
          return matchCategory && matchSearch;
        });
      },
      cartTotal() {
        return this.cartItems.reduce((sum, item) => sum + (item.quantity * item.referencePrice), 0);
      }
    },
    methods: {
      onSelectCategory(code) {
        this.selectedCategory = code;
      },
      addToCart(product) {
        const existing = this.cartItems.find(p => p.id === product.id);
        if (existing) {
          existing.quantity += 1;
        } else {
          this.cartItems.push({ ...product, quantity: 1 });
        }
      },
      updateCartItem({ id, quantity }) {
        const item = this.cartItems.find(i => i.id === id);
        if (item) item.quantity = quantity;
      },
      removeCartItem(id) {
        this.cartItems = this.cartItems.filter(i => i.id !== id);
      },
      resetCart() {
        this.cartItems = [];
      },
      onSelectCustomer(customer) {
        this.selectedClient = customer;
      },
      async checkout() {
        if (this.cartItems.length === 0) {
          this.$toast.error('Votre panier est vide. !');
          return;
        }

        const payload = {
          clientId: this.selectedClient?.id || null,
          paymentMethod: "CASH",
          sellerCode: "687c23e31e05982ddc4c2bc4",
          products: this.cartItems.map(item => ({
            productCode: item.code,
            quantity: item.quantity,
            unitPrice: item.referencePrice
          }))
        };

        this.isSubmitting = true;
        this.$loading(true);

        try {
          const { data } = await this.$http.post("/sales/pos", payload);
          swal("Succès", `Vente enregistrée. Référence : ${data}`, "success");
          this.resetCart();
          this.selectedClient = null;
        } catch (error) {
          showValidationErrors(error);
        } finally {
          this.isSubmitting = false;
          this.$loading(false);
        }
      }
    },
    mounted() {
      this.$http.get("/products").then(res => (this.products = res.data));
      this.$http.get("/registry/categories").then(res => (this.categories = res.data));
    }
  };
</script>

<style scoped>
.product-scroll-container {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  padding-right: 8px;
}
</style>